/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Представление попапа заказа товаров с удаленного склада меньше минимума со страницы товара
   */
  app.RemoteItemsPopupView = app.CartRemotePopupView.extend({
    el: '.js-remote-items-popup',

    // необходимый маркер для отправки событий в ОКО
    popupType: 'add_popup',
    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#remote-items-template');
      this.initPopup();
      this.listenTo(Backbone, 'show-remote-popup', this.render);
      this.listenTo(this.settlement, 'sync', this.updateSum);
    },
    /**
     * @inheritDoc
     */
    render: function (model, qty) {
      qty = qty || 1;

      var templateData = {
        item: model,
        qty: qty,
        currencySign: app.cart.currencySign,
        fractionNumber: app.helpers.NumberHelper.fractionNumber
      };
      this.$('.js-remote-content-container').html(this.template(templateData));
      this.open();
    },

    /**
     * Открываем попап
     */
    open: function () {
      // костыль для лебедевского попапа
      setTimeout(this.popup.open.bind(this.popup), 1);
      app.fader.show();
      this.saveCookie();
      this.okoPushOpen();
    },

    /**
     * Обновляем минимальную сумму для заказа.
     */
    updateSum: function () {
      this.$('.js-cart-status-sum').html(
        app.helpers.NumberHelper.fractionNumber(this.settlement.get('min_order_sum'))[0]
      );
    },

    /**
     * Установка куки isRemotePopupShown на 10 лет
     */
    saveCookie: function () {
      app.helpers.CookieHelper.setCookie(
        'isRemotePopupShown',
        1,
        {
          expires: 10*360*24*3600,
          path: '/'
        }
      );
    }
  });
})();

}.call(window));